// constants/menuData.js
const data = [
  {
    id: "home",
    icon: "fa fa-home",
    label: "داشبورد",
    to: "/",
    roles: "all",
    access_code: null,
  },
  {
    id: "manage-loads",
    icon: "fa fa-clipboard",
    label: "مدیریت بار",
    to: "/app/manage-loads",
    roles: ["Admin", "AdminSupport"],
    access_code: null,
    subs: [
      {
        icon: "fa fa-file-alt",
        label: "بارهای اعلام شده",
        to: "/AdminCargos",
        roles: ["Admin", "AdminSupport"],
        access_code: null,
      },
      {
        icon: "fa fa-clipboard-check",
        label: "لیست رزرو رانندگان",
        to: "/AdminDriverReserve",
        roles: ["Admin", "AdminSupport"],
        access_code: null,
      },
    ],
  },
  {
    id: "manage-drivers",
    icon: "fa fa-truck",
    label: "رانندگان",
    to: "/app/manage-drivers",
    roles: ["Admin", "AdminSupport"],
    access_code: null,
    subs: [
      {
        icon: "fa fa-search",
        label: "جستجوی راننده",
        to: "/Driver/Drivers",
        roles: ["Admin", "AdminSupport"],
        access_code: null,
      },
      {
        icon: "fa fa-user-plus",
        label: "افزودن راننده جدید",
        to: "/Driver/AddDriver",
        roles: ["Admin", "AdminSupport"],
        access_code: null,
      },
    ],
  },
  {
    id: "manage-transportationcompanys",
    icon: "fa fa-building",
    label: "شرکت",
    to: "/TransportationCompany",
    roles: ["Admin"],
    access_code: null,
  },
  {
    icon: "fa fa-user",
    label: "صاحبان کالا",
    to: "/ManageProductOwner",
    roles: ["Admin"],
    access_code: null,
  },
  // {
  //   id: "admin-loadhall-management",
  //   icon: "fa fa-warehouse",
  //   label: "سالن‌ها",
  //   to: "/LoadHalls",
  //   roles: ["Admin", "AdminSupport"],
  //   access_code: null,
  // },
  {
    id: "loads",
    icon: "fa fa-bullhorn",
    label: "مدیریت بار",
    to: "/app/loads",
    roles: [
      "TransportationCompanyAdmin",
      "TransportationCompanyMember",
      "ProductOwnerAdmin",
    ],
    access_code: null,
    subs: [
      {
        id: "loads-subs",
        label: "مدیریت بار",
        to: "/loads",
        roles: ["TransportationCompanyAdmin", "ProductOwnerAdmin"],
        access_code: null,
        subs: [
          {
            icon: "fa fa-plus-circle",
            label: "ثبت بار جدید",
            to: "/AddCargo",
            roles: ["TransportationCompanyAdmin", "ProductOwnerAdmin"],
            access_code: "access_Cargo_Add",
          },
          {
            icon: "fa fa-clipboard-list",
            label: "مدیریت بار ثبت شده ",
            to: "/Cargos",
            roles: ["TransportationCompanyAdmin", "ProductOwnerAdmin"],
            access_code: "access_Load_Manage",
          },
          {
            icon: "fa fa-clipboard-check",
            label: "مدیریت مجوز بارگیری",
            to: "/DriverReserves",
            roles: ["TransportationCompanyAdmin", "ProductOwnerAdmin"],
            access_code: "access_Reserve_List",
          },
        ],
      },
    ],
  },
  // {
  //   id: "bills",
  //   icon: "fa fa-bullhorn",
  //   label: "مدیریت حواله و بارنامه",
  //   to: "/app/bills",
  //   roles: ["TransportationCompanyAdmin"],
  //   access_code: null,
  //   subs: [
  //     {
  //       id: "bills-subs",
  //       label: "مدیریت حواله و بارنامه",
  //       to: "/bills",
  //       roles: ["TransportationCompanyAdmin"],
  //       access_code: null,
  //       subs: [
  //         {
  //           icon: "fa fa-plus-circle",
  //           label: "ثبت حواله",
  //           to: "/AddDraft",
  //           roles: ["TransportationCompanyAdmin"],
  //           access_code: "access_Draft_Add",
  //         },
  //         {
  //           icon: "fa fa-clipboard-list",
  //           label: "مدیریت حواله",
  //           to: "/Drafts",
  //           roles: ["TransportationCompanyAdmin"],
  //           access_code: "access_Draft_Manage",
  //         },
  //         {
  //           icon: "fa fa-clipboard-list",
  //           label: "مدیریت بارنامه",
  //           to: "/Bills",
  //           roles: ["TransportationCompanyAdmin"],
  //           access_code: "access_Bill_Manage",
  //         },
  //         {
  //           icon: "fa fa-clipboard-list",
  //           label: "ثبت اطلاعات مالی",
  //           to: "/FinancialBill",
  //           roles: ["TransportationCompanyAdmin"],
  //           access_code: "access_FinancialBill_Manage",
  //         },
  //       ],
  //     },
  //   ],
  // },
  // {
  //   id: "information-basic",
  //   icon: "fa fa-list-alt",
  //   label: "اطلاعات پایه",
  //   to: "/app/info-plus",
  //   roles: ["TransportationCompanyAdmin"],
  //   access_code: null,
  //   subs: [
  //     {
  //       id: "info-lists",
  //       label: "مدیریت",
  //       to: "/lists",
  //       roles: ["TransportationCompanyAdmin"],
  //       access_code: null,
  //       subs: [
  //         {
  //           icon: "fa fa-users",
  //           label: "مدیریت مشتریان",
  //           to: "/Customer",
  //           roles: ["TransportationCompanyAdmin"],
  //           access_code: "access_Customer_List",
  //         },
  //       ],
  //     },
  //   ],
  // },
  // {
  //   id: "reports",
  //   icon: "fa fa-chart-bar",
  //   label: "گزارشات",
  //   to: "/app/reports",
  //   roles: [
  //     "Admin",
  //     "AdminSupport",
  //     "Organization",
  //     "DriversAssociation",
  //     "AssociationTransportCompanies",
  //   ],
  //   access_code: null,
  //   subs: [
  //     {
  //       icon: "fa fa-chart-line",
  //       label: "گزارش کلی",
  //       to: "/FullReport",
  //       roles: [
  //         "TransportationCompanyMember",
  //         "TransportationCompanyAdmin",
  //         "AgentMain",
  //       ],
  //       access_code: null,
  //     },
  //     {
  //       id: "info-lists",
  //       label: "گزارشات پیش‌فرض",
  //       to: "/lists",
  //       icon: "fa fa-file-invoice-dollar",
  //       roles: [
  //         "TransportationCompanyMember",
  //         "TransportationCompanyAdmin",
  //         "AgentMain",
  //       ],
  //       access_code: null,
  //       subs: [
  //         {
  //           icon: "fa fa-money-bill-wave",
  //           label: "بارنامه - مالی",
  //           to: "/MaliReport",
  //           roles: [
  //             "TransportationCompanyMember",
  //             "TransportationCompanyAdmin",
  //             "AgentMain",
  //           ],
  //           access_code: null,
  //         },
  //         {
  //           icon: "fa fa-file-invoice",
  //           label: "بارنامه - حسابداری",
  //           to: "/HesabdariReport",
  //           roles: [
  //             "TransportationCompanyMember",
  //             "TransportationCompanyAdmin",
  //             "AgentMain",
  //           ],
  //           access_code: null,
  //         },
  //         {
  //           icon: "fa fa-exchange-alt",
  //           label: "بارنامه - فرستنده و گیرنده",
  //           to: "/FrestandeGirandeReport",
  //           roles: [
  //             "TransportationCompanyMember",
  //             "TransportationCompanyAdmin",
  //             "AgentMain",
  //           ],
  //           access_code: null,
  //         },
  //         {
  //           icon: "fa fa-shield-alt",
  //           label: "بارنامه - بیمه",
  //           to: "/BimehReport",
  //           roles: [
  //             "TransportationCompanyMember",
  //             "TransportationCompanyAdmin",
  //             "AgentMain",
  //           ],
  //           access_code: null,
  //         },
  //         {
  //           icon: "fa fa-route",
  //           label: "بارنامه - صورت وضعیت",
  //           to: "/SuratVaziatReport",
  //           roles: [
  //             "TransportationCompanyMember",
  //             "TransportationCompanyAdmin",
  //             "AgentMain",
  //           ],
  //           access_code: null,
  //         },
  //         {
  //           icon: "fa fa-star",
  //           label: "عملکرد رانندگان",
  //           to: "/amalkerd-report",
  //           roles: [
  //             "TransportationCompanyMember",
  //             "TransportationCompanyAdmin",
  //             "AgentMain",
  //           ],
  //           access_code: null,
  //         },
  //         {
  //           icon: "fa fa-hand-holding-usd",
  //           label: "گزارش پرداخت بارنامه",
  //           to: "/BillOfLadingPaymentReport",
  //           roles: [
  //             "TransportationCompanyMember",
  //             "TransportationCompanyAdmin",
  //             "AgentMain",
  //           ],
  //           access_code: null,
  //         },
  //       ],
  //     },
  //     {
  //       icon: "fa fa-calendar-alt",
  //       label: "گزارش نوبت رانندگان",
  //       to: "/DriverTurnList",
  //       roles: ["Admin", "AdminSupport"],
  //       access_code: null,
  //     },
  //     {
  //       icon: "fa fa-calendar-alt",
  //       label: "گزارش نوبت رانندگان",
  //       to: "/DriverTurnListUser",
  //       roles: [
  //         "Organization",
  //         "DriversAssociation",
  //         "AssociationTransportCompanies",
  //       ],
  //       access_code: null,
  //     },
  //   ],
  // },
  // {
  //   id: "manage-users",
  //   icon: "fa fa-users-cog",
  //   label: "کاربران",
  //   to: "/app/manage-users",
  //   roles: ["Admin"],
  //   access_code: null,
  //   subs: [
  //     {
  //       icon: "fa fa-user-shield",
  //       label: "مدیریت کاربران",
  //       to: "/AdminUser",
  //       roles: ["Admin"],
  //       access_code: null,
  //     },
  //   ],
  // },
  // {
  //   id: "manage-wallet",
  //   icon: "fa fa-wallet",
  //   label: "مدیریت کیف پول",
  //   to: "/app/manage-wallet",
  //   roles: ["TransportationCompanyAdmin"],
  //   access_code: null,
  //   subs: [
  //     {
  //       icon: "fa fa-coins",
  //       label: "افزایش موجودی",
  //       to: "/OnlineCharge",
  //       roles: ["TransportationCompanyAdmin"],
  //       access_code: null,
  //     },
  //     {
  //       icon: "fa fa-chart-pie",
  //       label: "گزارش کیف پول",
  //       to: "/TransportationCompanyAccountActivities",
  //       roles: ["TransportationCompanyAdmin"],
  //       access_code: null,
  //     },
  //   ],
  // },
  {
    id: "LoadHallCargo",
    icon: "fa fa-file-alt",
    label: "اعلام بار",
    to: "/LoadHallCargo",
    roles: ["LoadHallAdmin"],
    access_code: null,
  },
  {
    id: "LoadHallReserve",
    icon: "fa fa-clipboard-check",
    label: "رزرو رانندگان",
    to: "/LoadHallReserve",
    roles: ["LoadHallAdmin"],
    access_code: null,
  },
  {
    id: "DriverTurn",
    icon: "fa fa-clock",
    label: "نوبت‌دهی",
    to: "/DriverTurn",
    roles: ["LoadHallAdmin"],
    access_code: null,
  },
  {
    id: "DriverTurnList",
    icon: "fa fa-calendar-alt",
    label: "لیست نوبت رانندگان",
    to: "/DriverTurnList",
    roles: ["LoadHallAdmin"],
    access_code: null,
  },
  {
    id: "LoadHallShowTime",
    icon: "fa fa-cogs",
    label: "تنظیمات نمایش بار",
    to: "/LoadHallShowTime",
    roles: ["LoadHallAdmin"],
    access_code: null,
  },
  {
    id: "loads",
    icon: "fa fa-bullhorn",
    label: "بار ها",
    to: "/app/loads",
    roles: [
      "Organization",
      "DriversAssociation",
      "AssociationTransportCompanies",
    ],
    access_code: null,
    subs: [
      {
        id: "loads-subs",
        label: "اعلام بار",
        to: "/loads",
        roles: [
          "Organization",
          "DriversAssociation",
          "AssociationTransportCompanies",
        ],
        access_code: null,
        subs: [
          {
            icon: "fa fa-clipboard-list",
            label: "بارهای اعلام شده",
            to: "/CargosUsers",
            roles: [
              "Organization",
              "DriversAssociation",
              "AssociationTransportCompanies",
            ],
            access_code: "access_Load_Manage",
          },
          {
            icon: "fa fa-clipboard-check",
            label: "لیست مجوز رانندگان",
            to: "/DriverReservesUsers",
            roles: [
              "Organization",
              "DriversAssociation",
              "AssociationTransportCompanies",
            ],
            access_code: "access_Reserve_List",
          },
        ],
      },
    ],
  },
  {
    id: "comments",
    icon: "fa fa-comments",
    label: "مدیریت پیام",
    to: "/app/comments",
    roles: [
      "TransportationCompanyAdmin",
      "TransportationCompanyMember",
      "ProductOwnerAdmin",
    ],
    access_code: null,
    subs: [
      {
        id: "comments-subs",
        label: "مدیریت پیام",
        to: "/comments",
        roles: ["TransportationCompanyAdmin", "ProductOwnerAdmin"],
        access_code: null,
        subs: [
          {
            icon: "fa fa-cog",
            label: "مدیریت پیام",
            to: "/comment",
            roles: ["TransportationCompanyAdmin", "ProductOwnerAdmin"],
            access_code: "access_Cargo_Add",
          },
        ],
      },
    ],
  },
  {
    id: "admincomments",
    icon: "fa fa-comments",
    label: "پیام ها",
    to: "/app/admincomments",
    roles: ["Admin"],
    access_code: null,
    subs: [
      {
        id: "admincomments-subs",
        label: "پیام",
        to: "/admincomments",
        roles: ["Admin"],
        access_code: null,
        subs: [
          {
            icon: "fa fa-check-circle",
            label: "پیام ها",
            to: "/admincomment",
            roles: ["Admin"],
            access_code: "access_Cargo_Add",
          },
        ],
      },
    ],
  },
];

export default data;
